import { Clock, MapPin, Navigation, Phone } from 'lucide-react';
import './ClubLocations.css';

// Both clubs side by side, in the homepage's "Find your Delta Valley" style (owner direction, Sept 30):
// two equal cards, centered under one heading, with the hours lined up day by day.
export const CLUBS = [
  {
    key: 'brentwood', index: '01', label: 'Primary club', name: 'Brentwood',
    address: ['120 Guthrie Ln.', 'Brentwood, CA 94513'],
    hours: [['Mon–Thu', '4:30am–10:30pm'], ['Friday', '4:30am–9:00pm'], ['Sat–Sun', '6:00am–6:00pm']],
    map: 'https://maps.google.com/?q=120+Guthrie+Ln+Brentwood+CA+94513',
  },
  {
    key: 'discovery-bay', index: '02', label: 'East County', name: 'Discovery Bay',
    address: ['1520 Discovery Bay Blvd.', 'Discovery Bay, CA 94505'],
    hours: [['Mon–Thu', '6:00am–8:00pm'], ['Friday', '6:00am–5:00pm'], ['Sat–Sun', '7:00am–2:00pm']],
    map: 'https://maps.google.com/?q=1520+Discovery+Bay+Blvd+Discovery+Bay+CA+94505',
  },
];

export default function ClubLocations({ id = 'club-locations' }) {
  return (
    <section className="dv-clubs" aria-labelledby={`${id}-title`}>
      <div className="dv-clubs__head">
        <p className="dv-eyebrow">Two clubs · One community</p>
        <h2 className="dv-size-heading" id={`${id}-title`}>Hours &amp; <em>locations.</em></h2>
      </div>
      <div className="dv-clubs__grid">
        {CLUBS.map((club) => (
          <article key={club.key} className={`dv-clubs__club${club.index === '01' ? ' dv-clubs__club--primary' : ''}`} aria-labelledby={`${id}-${club.key}`}>
            <p className="dv-clubs__index">{club.index} · {club.label}</p>
            <h3 className="dv-size-subheading" id={`${id}-${club.key}`}>{club.name}</h3>
            <address><MapPin aria-hidden="true" /><span>{club.address[0]}<br />{club.address[1]}</span></address>
            <div className="dv-clubs__hours">
              <Clock aria-hidden="true" />
              <dl>
                {club.hours.map(([days, time]) => <div key={days}><dt>{days}</dt><dd>{time}</dd></div>)}
              </dl>
            </div>
            <div className="dv-clubs__links">
              <a href="tel:9252402990"><Phone aria-hidden="true" /> (925) 240-2990</a>
              <a href={club.map} target="_blank" rel="noreferrer"><Navigation aria-hidden="true" /> Directions</a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
